export default "https://cdn-static.gokick.com/assets/f56d8541e187cf36c438a68224daa166420c5eb6/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";